import { Box, Circle, HStack, Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import { useRouter } from 'next/router';
import * as React from 'react';

import { Semibold } from '@/imports/ui/chakra/components/Semibold';
import { PauseCircleIcon, RefreshCwIcon } from '@/imports/ui/chakra/feather';

import {
  EInAppNotificationType,
  IInAppSystemNotification,
} from '../../hooks/useInAppSystemNotifications';

dayjs.extend(relativeTime);
dayjs.extend(utc);

type IInAppSystemNotificationItemProps = {
  notification: IInAppSystemNotification;
  markRead: (notificationId: string) => Promise<void>;
};

export const InAppSystemNotificationItem: React.FC<
  IInAppSystemNotificationItemProps
> = (props) => {
  const { notification, markRead } = props;
  const router = useRouter();
  const isPaused =
    notification.type === EInAppNotificationType.GroupAccessPolicyPaused;
  const Icon = isPaused ? PauseCircleIcon : RefreshCwIcon;
  const updatedAt = notification.dateCreated
    ? dayjs.utc(notification.dateCreated)
    : null;

  const onClick = async (): Promise<void> => {
    await markRead(notification._id);
    if (notification.groupId) {
      router.push(`/community/groups/${notification.groupId}/activity`);
    }
  };

  const body =
    notification.groupName &&
    notification.body.includes(notification.groupName) ? (
      <Text noOfLines={2}>
        {notification.body.split(notification.groupName)[0]}
        <Semibold>{notification.groupName}</Semibold>
        {notification.body.split(notification.groupName)[1]}
      </Text>
    ) : (
      <Text noOfLines={2}>{notification.body}</Text>
    );

  return (
    <Box
      as="button"
      textAlign="left"
      px="4"
      py="2"
      backgroundColor={notification.isRead ? 'white' : 'primary.50'}
      onClick={onClick}
      w="full"
      borderRadius="lg"
    >
      <HStack>
        <Circle backgroundColor="primary.500" size={16} boxShadow="base">
          <Icon boxSize={8} color="white" strokeWidth="1.5" />
        </Circle>
        <Box ml="4">
          <Box>{body}</Box>
          {updatedAt ? (
            <Box>
              <Text textStyle="detail">
                <time dateTime={updatedAt.toISOString()}>
                  {updatedAt.fromNow()}
                </time>
              </Text>
            </Box>
          ) : null}
        </Box>
      </HStack>
    </Box>
  );
};
